import { render, staticRenderFns } from "./PropRow.vue?vue&type=template&id=324b8ae8"
import script from "./PropRow.vue?vue&type=script&lang=js"
export * from "./PropRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports